import PropTypes from "prop-types"
import React, { useState } from "react"
import { Col, Container, Row } from "reactstrap"

import Breadcrumb from "components/Common/Breadcrumb2"
import OffCanvasFilter from "components/OffCanvasFilter/OffCanvasFilter"
import { withTranslation } from "react-i18next"
import DashboardTable from "./Components/DashboardTable"
import StatusEsteira from "./Components/StatusEsteira"

const Indicadores = props => {
  document.title = "Indicadores | Sensetek"

  const [showFilter, setShowFilter] = useState(false)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Resumo")}
            breadcrumbItems={[{ title: props.t("Indicadores"), path: "#" }]}
          />
          <Row>
            <Col className="d-flex flex-row-reverse">
              <button
                className="btn filter-item noti-icon right-bar-toggle text-end"
                type="button"
                onClick={() => {
                  setShowFilter(true)
                }}
              >
                <i className="bx bx-filter" />
              </button>
              <OffCanvasFilter
                showFilter={showFilter}
                setShowFilter={setShowFilter}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Col>
                <StatusEsteira cardsNumber={6} reportId={17} />
              </Col>
            </Col>
          </Row>
          <Row>
            <Col>
              <DashboardTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Indicadores.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Indicadores)
